import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { EMPTY, Observable, from, of } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap';
import { DropzoneConfigInterface, DropzoneDirective } from 'ngx-dropzone-wrapper';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AngularModalService } from 'src/app/core/services/modal.service';
import { DocumentActionService } from 'src/app/core/services/document-action-service';
import { DocumentService } from 'src/app/core/services/document.service';
import { SharedService } from 'src/app/core/services/shared.service';
import { UserService } from 'src/app/core/services/user.service';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';
import {
  CandidateProfileActionsModalComponent
} from 'src/app/pages/mission-control-page/candidateprofile-page/candidate-profile-actions-modal/candidate-profile-actions-modal.component';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-email-documents',
  templateUrl: './email-documents.component.html',
  styleUrls: ['./email-documents.component.css']
})
export class EmailDocumentsComponent implements OnInit, OnDestroy {
  @Input() context: string;
  @Input() document: any;
  @Input() documents: any[];
  @Input() candidateDetails: any;
  @Input() folders: any[];
  @Input() candidateJobMatchFolders: any[];
  @Input() hasResume: any;
  @Input() sourceScreen: string;
  @Input() formalizeActivityPayload: any;
  @Output() saveCallback = new EventEmitter<any>();
  @Output() cancelCallback = new EventEmitter<any>();

  @ViewChild('emailDocumentsForm') emailDocumentsForm: NgForm;
  @ViewChild(DropzoneDirective) emailDocumentUploadDropZone: DropzoneDirective;

  companyId: any;
  userId: any;
  loggedIdCompanyName: any;
  loggedInUserName: any;
  isStaffingCompany: boolean;
  loggedInUserEmailId: any;
  attachedDocuments: any[] = [];
  documentsSectionHtml = '';
  availableDocuments: any[] = [];
  selectedEmailSendToObjectsArray: any[] = [];
  selectedEmailCCObjectsArray: any[] = [];
  selectedEmailBCCObjectsArray: any[] = [];
  defaultCandidateEmail: any = null;
  userSearchPlaceholder = 'Type email to search.';
  emailDocumentFolderId: any = null;
  selectedJobMatchList: any[] = [];
  candidateAssessmentFiles: any[] = [];
  candidateInformationList: any[] = [];
  addedEmailCount = 0;
  savingFlag = false;
  isRequisitionUsersSelected = true;
  emailDetails: any = {
    documentIds: [],
    emailUsers: [],
    subject: '',
    ccUsers: [],
    bccUsers: [],
    body: ''
  };
  searchUsersForEmail: any = null;
  candidateId: any;
  jobMatchId: any;
  candidateType: any;
  uploadEmailDocumentResponse: any = null;
  fileUploadInProgressFlag = false;
  disableUploadButtonFlag = false;
  isAttachDocuments = false;
  isCandidateJobMatch = false;
  isExistingDocumentsAvailable = false;
  isPrePopulatedUsersAvailable = false;
  showClientForReviewCheckbox = false;
  selectAllCandidates = false;
  selectAllCandidatesExternal = false;
  externalCandidateAction: any = null;
  isSendForReviewSelected = false;
  selectedCandidateFieldsForReview: any[] = [];
  displayedBody = '';
  dropzoneConfig: DropzoneConfigInterface;

  private emailSignature = '';
  private adjustHeightObserver: MutationObserver;
  private adjustHeightResizeHandler: () => void;

  // Bound as ngx-chips tag-input-dropdown [autocompleteObservable] for each field.
  getEmailIdsToObservable = (term: string): Observable<any[]> => from(this.getEmailIds(term, 'to'));
  getEmailIdsCcObservable = (term: string): Observable<any[]> => from(this.getEmailIds(term, 'cc'));
  getEmailIdsBccObservable = (term: string): Observable<any[]> => from(this.getEmailIds(term, 'bcc'));

  // ngx-chips [onAdding] validator: matches legacy validateTypeAheadTags - rejects a
  // free-typed tag unless it is a valid email address; tags selected from the
  // autocomplete dropdown (with an id) are always accepted.
  validateTypeAheadTag = (tag: any): Observable<any> => {
    if (tag.id) {
      return of(tag);
    }
    const rawName = tag.name || tag.value;
    if (rawName && MESSAGECONSTANTS.VALIDATIONPATTERNS.EMAIL.test(rawName)) {
      return of({ id: null, email: rawName, displayString: '', name: rawName });
    }
    return EMPTY;
  }

  constructor(
    private modalService: AngularModalService,
    private documentService: DocumentService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private documentActionService: DocumentActionService,
    private userService: UserService,
    private bsModalService: BsModalService,
    private sharedService: SharedService,
    private authService:AuthService
  ) { }

  ngOnInit() {
    this.companyId = this.authService.getUserDetails().company.companyId;
    this.userId = this.authService.getUserDetails().id;
    this.loggedIdCompanyName = this.authService.getUserDetails().company.companyName;
    this.loggedInUserName = this.authService.getUserDetails().firstname + ' ' + this.authService.getUserDetails().lastname;
    this.isStaffingCompany = this.authService.getUserDetails().company.companyType === 'StaffingCompany';
    this.loggedInUserEmailId = this.authService.getUserDetails().emailId;

    const defaultLoggedInUserEmail = {
      id: this.userId,
      email: this.loggedInUserEmailId,
      displayString: '',
      name: `${this.loggedInUserName}`,
      isCompanyUser: this.isStaffingCompany
    };

    if (this.candidateDetails && this.candidateDetails.candidateEmail) {
      this.emailDetails.emailUsers.push({ email: this.candidateDetails.candidateEmail });
      this.defaultCandidateEmail = {
        id: this.candidateDetails.candidateId,
        email: this.candidateDetails.candidateEmail,
        displayString: '',
        name: `${this.candidateDetails.candidateEmail}`
      };
      this.selectedEmailSendToObjectsArray.push(this.defaultCandidateEmail);
      this.emailDetails.ccUsers.push({ email: this.loggedInUserEmailId });
      this.selectedEmailCCObjectsArray.push(defaultLoggedInUserEmail);
    } else {
      this.emailDetails.ccUsers.push({ email: this.loggedInUserEmailId });
      this.selectedEmailCCObjectsArray.push(defaultLoggedInUserEmail);
    }

    if (this.candidateDetails) {
      this.candidateId = this.candidateDetails.candidateId;
      this.jobMatchId = this.candidateDetails.jobMatchId;
      if (this.candidateDetails.candidateEmailSubjectAndBodyInformation) {
        this.emailDetails.subject = this.candidateDetails.candidateEmailSubjectAndBodyInformation.subject;
        this._setEmailBodyPrePopulatedInformation();
        this.candidateInformationList = _.cloneDeep(this.candidateDetails.candidateEmailSubjectAndBodyInformation.candidateInfoInEmailBody);
      }
    }

    if (this.candidateDetails && !this.candidateId && this.document) {
      this.candidateId = this.document.candidateId;
    }

    if (this.documents && this.document) {
      this.availableDocuments = this.documents;
      this.attachedDocuments = this.documents.filter(doc => doc.id === this.document.id);
      this.attachedDocuments.forEach(doc => {
        doc.selected = true;
      });
    }

    if (!this.folders && !this.candidateJobMatchFolders) {
      if (this.candidateDetails.context === 'candidateJobMatchCard') {
        this.candidateJobMatchFolders = [];
        this._setUserToEmailSearchObject();
        this._setPrePopulatedEmailUsersList(this.candidateDetails.jobMatchId);
      }
      this.getAllCandidateFolders(null, () => { });
    } else {
      if (this.candidateDetails.context === 'candidateJobMatchCard') {
        if (this.candidateDetails.jobMatchId) {
          this.candidateJobMatchFolders = this.candidateJobMatchFolders.filter(
            jobMatch => this.candidateDetails.jobMatchId === jobMatch.jobMatch.jobMatchId);
          this._setPrePopulatedEmailUsersList(this.candidateDetails.jobMatchId);
        }
      } else {
        this._setPrePopulatedEmailUsersList(undefined);
      }
      this.isExistingDocumentsAvailable = true;
      this._setUserToEmailSearchObject();
      this.isPrePopulatedUsersAvailable = true;
    }

    this.dropzoneConfig = this._getDropZoneSettings();

    setTimeout(() => {
      this.adjustAttachedDocumentsHeight();
    }, 300);

    this._setCandidateAssessmentReports();

    this._handleFilterDisplay();

    this.emailSignature = this.emailDetails.body || '';
  }

  ngOnDestroy() {
    if (this.adjustHeightObserver) {
      this.adjustHeightObserver.disconnect();
    }
    if (this.adjustHeightResizeHandler) {
      $(window).off('resize', this.adjustHeightResizeHandler);
    }
  }

  // Receive formalized email content from downgraded FormalizeComment component
  receiveFormalizedEmail(output: any) {
    if (!output) { return; }
    if (output.subject) {
      this.emailDetails.subject = output.subject;
    }
    if (output.body) {
      if (output.isHtml) {
        this.emailDetails.body = output.body + (this.emailSignature || '');
        this.displayedBody = this.emailDetails.body;
      } else {
        let bodyPlain = output.body.toString().trim();
        const signatureHtml = this.emailSignature || '';
        const signatureText = signatureHtml.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
        if (signatureText) {
          const bodyLower = bodyPlain.toLowerCase();
          const sigLower = signatureText.toLowerCase();
          if (bodyLower.endsWith(sigLower)) {
            bodyPlain = bodyPlain.slice(0, bodyPlain.length - signatureText.length).trim();
          } else {
            const idx = bodyLower.lastIndexOf(sigLower);
            if (idx !== -1) {
              bodyPlain = bodyPlain.slice(0, idx).trim();
            }
          }
        }
        const htmlBody = bodyPlain.split(/\n{1,}/).map(p => `<p>${p.trim()}</p>`).join('');
        this.emailDetails.body = htmlBody + (this.emailSignature || '');
        this.displayedBody = this.emailDetails.body;
      }
    }
    this.alertsAndNotificationsService.showBannerMessage('Email content enhanced by AI.', 'success');
  }

  onEmailDocumentFileAdded(file: any) {
    this.fileUploadInProgressFlag = true;
    this.disableUploadButtonFlag = true;
    if (file) {
      $('.dz-preview').remove();
      this.uploadEmailDocumentToUpload();
    }
  }

  onEmailDocumentFileSendingMultiple(args: any) {
    const formData = args[2];
    formData.append('companyId', this.companyId);
    formData.append('candidateId', this.candidateId);
    formData.append('internalNote', '');
    formData.append('sharedEntityIds', null);
    formData.append('shareDocument', false);
    formData.append('folderId', this.emailDocumentFolderId);
    formData.append('candidateType', this.candidateDetails.candidateType);
    formData.append('userId', this.userId);
  }

  onEmailDocumentFileSuccessMultiple(args: any) {
    const response = args[1];
    this.uploadEmailDocumentResponse = response;
    if (response) {
      this._setAttachedDocuments(response);
    } else {
      this.fileUploadInProgressFlag = false;
      this.disableUploadButtonFlag = false;
    }
    this.alertsAndNotificationsService.showBannerMessage('Document(s) added successfully.', 'success');
    this.emailDocumentUploadDropZone.dropzone().removeAllFiles();
  }

  onEmailDocumentFileError(args: any) {
    const error = args[1];
    this.fileUploadInProgressFlag = false;
    const errorMessage = error.message ? error.message : error;
    this.alertsAndNotificationsService.showBannerMessage(errorMessage, 'error');
    this.fileUploadInProgressFlag = false;
    this.disableUploadButtonFlag = false;
    this.emailDocumentUploadDropZone.dropzone().removeAllFiles();
  }

  private _getDropZoneSettings(): DropzoneConfigInterface {
    const maxFilesToUpload = 2;
    let dropZoneSettings = {};
    dropZoneSettings = {
      url: this.documentService.getUploadUrl(),
      paramName: () => 'files',
      acceptedFiles: '.pdf,.xlsx,.docx,.doc',
      maxFiles: maxFilesToUpload,
      maxFilesize: 10,
      maxThumbnailFilesize: 10,
      timeout: 300000,
      addRemoveLinks: true,
      autoProcessQueue: false,
      uploadMultiple: true,
      parallelUploads: 100
    };
    return dropZoneSettings;
  }

  private _buildDocumentsSectionHtml() {
    const selectedAssessments = (this.candidateAssessmentFiles || []).filter(f => f.isSelected);
    const hasAttached = this.attachedDocuments && this.attachedDocuments.length > 0;
    if (!hasAttached && selectedAssessments.length === 0) {
      this.documentsSectionHtml = '';
      return;
    }
    let html = '<p id="doc-attach-header"><b>Document(s) attached:-</b></p>';
    selectedAssessments.forEach(file => {
      html += `<p><b>${file.name}:</b> ${file.resumeNameOrXrXml}</p>`;
    });
    if (hasAttached) {
      this.attachedDocuments.forEach(doc => {
        if (doc.isJobMatchDocument) {
          const displayLabel = doc.displayLabel || doc.fileName;
          const displayFileName = doc.displayFileName || doc.fileName;
          html += `<p><b>${displayLabel}:</b> ${displayFileName}</p>`;
        } else {
          const label = this._getDocumentLabel(doc);
          if (label) {
            html += `<p><b>${label}:</b> ${doc.fileName}</p>`;
          } else {
            html += `<p><b>${doc.fileName}</b></p>`;
          }
        }
      });
    }
    html += '<p><br/></p>';
    this.documentsSectionHtml = html;
  }

  onAssessmentFileChange() {
    this._buildDocumentsSectionHtml();
  }

  private _getDocumentLabel(doc: any) {
    if (doc.folderId && this.folders) {
      for (const folder of this.folders) {
        if (folder.id === doc.folderId) {
          if (folder.name === 'Resume') { return 'Resume'; }
          if (folder.name === 'Technical Assessment') { return 'Technical Assessment'; }
          return null;
        }
        if (folder.folders) {
          for (const subFolder of folder.folders) {
            if (subFolder.id === doc.folderId) {
              if (subFolder.name === 'Resume') { return 'Resume'; }
              if (subFolder.name === 'Technical Assessment') { return 'Technical Assessment'; }
              if (folder.name === 'Resume') { return 'Resume'; }
              if (folder.name === 'Technical Assessment') { return 'Technical Assessment'; }
              return null;
            }
          }
        }
      }
    }
    return null;
  }

  private _setAttachedDocuments(response: any) {
    this.getAllCandidateFolders(response, () => {
      this.fileUploadInProgressFlag = false;
      this.disableUploadButtonFlag = false;
    });
  }

  attachDocument(document: any) {
    let checkIfDocExists = false;
    this.attachedDocuments.every(doc => {
      if (doc.id === document.id) {
        checkIfDocExists = true;
        return false;
      }
      return true;
    });

    if (!checkIfDocExists) {
      this.attachedDocuments.push(document);
      this._buildDocumentsSectionHtml();
    }
  }

  detachDocument(document: any) {
    this.attachedDocuments = this.attachedDocuments.filter(doc => doc.id !== document.id);
    this._buildDocumentsSectionHtml();
  }

  private _setJobMatchSelectedDocumentObj(jobMatchDocument: any) {
    const tempObj: any = {
      jobId: jobMatchDocument.jobMatch.jobId,
      jobMatchTitle: jobMatchDocument.jobMatch.jobMatchTitle,
      jobMatchRequisitionNum: jobMatchDocument.jobMatch.jobMatchRequisitionNum,
      jobMatchId: jobMatchDocument.jobMatch.jobMatchId,
      testInvitationId: null,
      sendRecruiterScreeningFeedbackReport: false,
      sendPhoneScreeningFeedbackReport: false,
      sendInterviewFeedbackReport: false,
      sendTechAssessmentReport: false,
      sendOutreachFeedbackReport: false
    };

    switch (jobMatchDocument.fileName) {
      case 'Tech Assessment':
        tempObj.testInvitationId = jobMatchDocument.jobMatch.techAssessmentInvitationId;
        tempObj.sendTechAssessmentReport = true;
        break;
      case 'Value Assessment':
        tempObj.valueAssessmentInvitationId = jobMatchDocument.jobMatch.valueAssessmentInvitationId;
        tempObj.sendValueAssessmentReport = true;
        break;
      case 'Recruiter Screening Feedback':
        tempObj.sendRecruiterScreeningFeedbackReport = true;
        break;
      case 'Phone Screen Feedback':
        tempObj.sendPhoneScreeningFeedbackReport = true;
        break;
      case 'Interview Feedback':
        tempObj.sendInterviewFeedbackReport = true;
        break;
      case 'Outreach Feedback':
        tempObj.sendOutreachFeedbackReport = true;
        break;
      default:
        break;
    }

    return tempObj;
  }

  private _setCandidateDocumentsToEmail() {
    const candidateDocuments: any[] = [];
    const allFolders: any[] = [];

    this.folders.map(parentFolder => {
      allFolders.push(parentFolder);
      if (parentFolder.folders && parentFolder.folders.length > 0) {
        parentFolder.folders.map((childFolder: any) => allFolders.push(childFolder));
      }
    });

    this.attachedDocuments.map(document => {
      if (!document.isJobMatchDocument) {
        const tempDocument: any = {};
        tempDocument.documentId = document.id;
        tempDocument.documentName = document.fileName;
        tempDocument.folderId = document.folderId;
        this.documentActionService.setParentAndChildFolderName(allFolders, tempDocument);
        candidateDocuments.push(tempDocument);
      }
    });

    return candidateDocuments;
  }

  private _setJobMatchesDocumentsToEmail() {
    const selectedJobMatchDocuments = this.attachedDocuments.filter(doc => doc.isJobMatchDocument);
    const emailJobMatchObjList: any[] = [];
    if (selectedJobMatchDocuments.length > 0) {
      selectedJobMatchDocuments.map(jobMatchDocument => {
        emailJobMatchObjList.push(this._setJobMatchSelectedDocumentObj(jobMatchDocument));
      });
    }
    return emailJobMatchObjList;
  }

  private _setCandidateResumesToEmail(type: string) {
    if (this.candidateAssessmentFiles.length > 0) {
      let assessmentDocument: any;
      this.candidateAssessmentFiles.map(data => {
        if (data.name === type) {
          assessmentDocument = data;
        }
      });
      return assessmentDocument.isSelected;
    } else {
      return false;
    }
  }

  private _mapCandidateFieldsToReviewFormat() {
    const fieldMappingByName: any = {
      'Full Name': { key: 'FULL_NAME', label: 'Full Name' },
      'Phone Number': { key: 'PHONE_NUMBER', label: 'Phone Number' },
      Email: { key: 'EMAIL', label: 'Email' },
      Address: { key: 'ADDRESS', label: 'Address' },
      'Current Location': { key: 'CURRENT_LOCATION', label: 'Current Location' },
      'Current Role': { key: 'CURRENT_ROLE', label: 'Current Role' },
      'Current Company': { key: 'CURRENT_COMPANY', label: 'Current Company' },
      'Seeking Job Type': { key: 'SEEKING_JOB_TYPE', label: 'Seeking Job Type' },
      'Desired Salary/Rate': { key: 'DESIRED_SALARY_RATE', label: 'Desired Salary/Rate' },
      Sponsorship: { key: 'SPONSORSHIP', label: 'Sponsorship' },
      'Willing To Relocate': { key: 'WILLING_TO_RELOCATE', label: 'Willing to Relocate' },
      'Willing to Relocate': { key: 'WILLING_TO_RELOCATE', label: 'Willing to Relocate' },
      'Linkedin Url': { key: 'LINKEDIN_URL', label: 'LinkedIn URL' },
      'LinkedIn URL': { key: 'LINKEDIN_URL', label: 'LinkedIn URL' }
    };

    const fieldMappingById: any = {
      name: { key: 'FULL_NAME', label: 'Full Name' },
      phone_number: { key: 'PHONE_NUMBER', label: 'Phone Number' },
      email: { key: 'EMAIL', label: 'Email' },
      address: { key: 'ADDRESS', label: 'Address' },
      current_location: { key: 'CURRENT_LOCATION', label: 'Current Location' },
      current_role: { key: 'CURRENT_ROLE', label: 'Current Role' },
      current_company: { key: 'CURRENT_COMPANY', label: 'Current Company' },
      seeking_job_type: { key: 'SEEKING_JOB_TYPE', label: 'Seeking Job Type' },
      'desired_salary.rate': { key: 'DESIRED_SALARY_RATE', label: 'Desired Salary/Rate' },
      sponsorship: { key: 'SPONSORSHIP', label: 'Sponsorship' },
      willing_to_relocate: { key: 'WILLING_TO_RELOCATE', label: 'Willing to Relocate' },
      linkedin_url: { key: 'LINKEDIN_URL', label: 'LinkedIn URL' }
    };

    const clientReviewIncludeFields: any[] = [];
    let displayOrder = 1;

    let fieldsToProcess = this.selectedCandidateFieldsForReview;

    if ((!fieldsToProcess || fieldsToProcess.length === 0) && this.candidateInformationList && this.candidateInformationList.length > 0) {
      fieldsToProcess = this.candidateInformationList.filter(c => c.selected);
    }

    if (fieldsToProcess && fieldsToProcess.length > 0) {
      fieldsToProcess.forEach((field: any) => {
        let fieldMap = fieldMappingByName[field.name];

        if (!fieldMap) {
          fieldMap = fieldMappingById[field.id];
        }

        if (!fieldMap) {
          const generatedKey = (field.name || field.id)
            .toUpperCase()
            .replace(/\s+/g, '_')
            .replace(/[/\-]/g, '_');

          fieldMap = {
            key: generatedKey,
            label: field.name || field.id
          };
        }

        const fieldValue = this._getFieldValue(field);

        clientReviewIncludeFields.push({
          fieldKey: fieldMap.key,
          fieldLabel: fieldMap.label,
          fieldValue,
          displayOrder
        });
        displayOrder++;
      });
    }

    return clientReviewIncludeFields;
  }

  private _getFieldValue(field: any) {
    if (!field || !field.value) {
      return 'Not Specified';
    }

    const valueStr = field.value.toString().trim();

    if (valueStr === '') {
      return 'Not Specified';
    }

    return valueStr;
  }

  private _setEmailDetails() {
    const emailDetails: any = {
      candidateId: this.candidateId,
      userId: this.userId,
      candidateType: this.candidateDetails.candidateType,
      companyId: this.companyId,
      jobMatchId: this.candidateDetails.jobMatchId,
      candidateDocuments: {
        documents: this._setCandidateDocumentsToEmail(),
        sendResume: this._setCandidateResumesToEmail('Resume'),
        sendResumeHRXML: this._setCandidateResumesToEmail('Resume HR Xml')
      },
      jobMatchesDocuments: this._setJobMatchesDocumentsToEmail(),
      currentStep: this.candidateDetails.currentStep,
      emailDetails: {
        emailUsers: this.emailDetails.emailUsers,
        subject: this.emailDetails.subject,
        ccUsers: this.emailDetails.ccUsers,
        bccUsers: this.emailDetails.bccUsers,
        body: this.emailDetails.body
      }
    };

    if (this.isSendForReviewSelected) {
      emailDetails.emailDetails.sentToClientForReview = true;
      emailDetails.emailDetails.clientReviewIncludeFields = this._mapCandidateFieldsToReviewFormat();
    }

    return emailDetails;
  }

  private _checkIfMoreThanTwoCompanyEmailIdsExists() {
    const allClientOrBuNames: any[] = [];
    const allSelectedEmailTagObjects = [
      ...this.selectedEmailSendToObjectsArray, ...this.selectedEmailCCObjectsArray, ...this.selectedEmailBCCObjectsArray
    ];
    if (allSelectedEmailTagObjects.length > 1) {
      if (this.isStaffingCompany) {
        allSelectedEmailTagObjects.map(data => {
          if (data.companyName) {
            allClientOrBuNames.push(data.companyName);
          }
        });
        const uniqueClientOrBuSet = new Set(allClientOrBuNames);
        return uniqueClientOrBuSet.size !== 1;
      } else {
        allSelectedEmailTagObjects.map(data => {
          allClientOrBuNames.push(data.staffingCompany);
        });
        const uniqueClientOrBuSet = new Set(allClientOrBuNames);
        return uniqueClientOrBuSet.size !== 1;
      }
    } else {
      return false;
    }
  }

  private _checkIfNonCompanyEmailExists() {
    const allSelectedEmailTagObjects = [
      ...this.selectedEmailSendToObjectsArray, ...this.selectedEmailCCObjectsArray, ...this.selectedEmailBCCObjectsArray
    ];
    if (allSelectedEmailTagObjects.length > 0) {
      let nonCompanyEmailExists = false;
      allSelectedEmailTagObjects.map(data => {
        if (!data.id || data.id.toString().length < 3) {
          nonCompanyEmailExists = true;
        }
      });
      return nonCompanyEmailExists;
    } else {
      return false;
    }
  }

  private _sendMail(emailDetails: any) {
    this.savingFlag = true;
    this.documentService.emailDocuments(emailDetails, () => {
      this.alertsAndNotificationsService.showBannerMessage('Email sent successfully', 'success');
      this.savingFlag = false;
      if (this.saveCallback) {
        this.saveCallback.emit();
      }
    }, (error: any) => {
      this.savingFlag = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  sendMail() {
    if (this.emailDocumentsForm && !this.emailDocumentsForm.invalid && this.selectedEmailSendToObjectsArray.length > 0) {
      this._syncEditorContentToModel();

      const emailDetails = this._setEmailDetails();
      if (this._checkIfMoreThanTwoCompanyEmailIdsExists() || this._checkIfNonCompanyEmailExists()) {
        this.savingFlag = true;
        const clientOrBu = this.authService.getUserDetails().company.companyType === 'Corporation' ? 'BU' : 'Client';
        const title = `Different ${clientOrBu}`;
        const message = `<div>
                                    <p>Email and/or document(s) being sent to email address(es) outside the company.<p>
                                    <p>Send anyway?</p>
                               </div>`;
        this.alertsAndNotificationsService.showConfirm(title, message, 'warning', false, () => {
          this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
          this._sendMail(emailDetails);
        }, () => {
          this.savingFlag = false;
          this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        });
      } else {
        this._sendMail(emailDetails);
      }
    }
  }

  cancel() {
    if (this.cancelCallback) {
      this.cancelCallback.emit();
    }
  }

  private _syncEditorContentToModel() {
    const editorElem = document.querySelector('app-ngx-editor [contenteditable="true"]');
    if (editorElem && editorElem.innerHTML) {
      this.emailDetails.body = editorElem.innerHTML;
    }
  }

  attachDocuments() {
    const actionType = 'attachDocuments';
    const actionLabel = 'Attach Document';
    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    setTimeout(() => {
      const candidateProfileActionsModal = this.bsModalService.show(CandidateProfileActionsModalComponent, {
        initialState: {
          actionType,
          actionLabel,
          documents: _.cloneDeep(this.attachedDocuments),
          availableDocuments: this.availableDocuments,
          folders: this.folders,
          candidateJobMatchFolders: this.candidateJobMatchFolders
        },
        class: 'custom-candidate-profile-modal custom-modal-xl'
      });

      candidateProfileActionsModal.content.onClose.subscribe((callbackObject: any) => {
        if (callbackObject && callbackObject.entity && callbackObject.entity.length > 0) {
          this.attachedDocuments = callbackObject.entity;
          this._buildDocumentsSectionHtml();
        }
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      });
    }, 300);
  }

  private _setCandidateJobMatchFolders(jobMatches: any) {
    this.candidateJobMatchFolders = [];
    this.candidateJobMatchFolders = this.documentActionService.setCandidateJobMatchFolders(jobMatches, this.companyId, this.candidateId);
  }

  private _setFolders(folders: any[]) {
    folders.forEach(folder => {
      folder.folders.forEach((subFolder: any) => {
        subFolder.parentFolderId = folder.id;
        subFolder.parentFolderName = folder.name;
      });
    });
    this.folders = folders;
    this.documentActionService._setDocumentIcons(this.folders);
  }

  getAllCandidateFolders(response: any, successCallback: () => void) {
    const candidateType = this.candidateType ? this.candidateType : this.candidateDetails.candidateType;
    this.documentService.getAllCandidateFolders(this.candidateId, this.companyId, candidateType, (data: any) => {
      this._setFolders(data.candidateDocuments);
      if (this.candidateDetails && this.candidateDetails.context === 'candidateJobMatchCard') {
        const currentCandidateJobMatch = data.jobMatchesDocuments.filter(
          (jobMatch: any) => this.candidateDetails.jobMatchId === jobMatch.jobMatchId);
        this._setCandidateJobMatchFolders(currentCandidateJobMatch);
      } else {
        this._setCandidateJobMatchFolders(data.jobMatchesDocuments);
      }
      this.folders = this.documentActionService.setSharedFolderWithDocuments(this.folders, this.candidateId, this.companyId);
      let allDocuments: any[] = [];
      let parentDocuments: any[] = [];
      let childDocuments: any[] = [];
      this.folders.map(folder => {
        if (folder.name === 'Email Documents') {
          this.emailDocumentFolderId = folder.id;
        }
        parentDocuments = [...folder.documents];
        childDocuments = [];
        folder.folders.forEach((subFolder: any) => {
          childDocuments = [...childDocuments, ...subFolder.documents];
        });
        allDocuments = [...allDocuments, ...parentDocuments, ...childDocuments];
      });
      this.availableDocuments = allDocuments;

      if (response) {
        response.map((document: any) => {
          const index = _.findIndex(allDocuments, { fileName: document.fileName });
          allDocuments[index].selected = true;
          this.attachedDocuments.push(allDocuments[index]);
        });
      } else if (!this.documents || !this.document) {
        this.attachedDocuments = [];
      }

      if (this.candidateDetails.context !== 'candidateJobMatchCard') {
        this._setUserToEmailSearchObject();
        this._setPrePopulatedEmailUsersList(undefined);
      }
      this._buildDocumentsSectionHtml();
      if (successCallback) {
        successCallback();
      }
      this.isExistingDocumentsAvailable = true;
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  addEmailDocumentFolder(successCallback: (data: any) => void) {
    const folder = {
      candidateId: this.candidateId,
      companyId: this.companyId,
      description: 'Email Documents',
      name: 'Email Documents',
      parentFolderId: null
    };

    this.documentService.addCandidateDocumentFolder(folder, (data: any) => {
      this.emailDocumentFolderId = data.id;
      if (successCallback) {
        successCallback(data);
      }
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  openFileSelectionModal() {
    document.getElementById('emailDocumentUploadDropzone').click();
  }

  uploadEmailDocumentToUpload() {
    setTimeout(() => {
      this.emailDocumentUploadDropZone.dropzone().processQueue();
    }, 500);
  }

  attachDocumentsToEmail() {
    this.folders.map(folder => {
      if (folder.name === 'Email Documents') {
        this.emailDocumentFolderId = folder.id;
      }
    });

    if (this.emailDocumentFolderId) {
      this.openFileSelectionModal();
    } else {
      this.addEmailDocumentFolder(() => {
        this.openFileSelectionModal();
      });
    }
  }

  private _setEmailNewTag(tag: any, type: string) {
    this.addedEmailCount += 1;
    const tempTag = { id: this.addedEmailCount, email: tag.email, displayString: '', name: tag.name, isNewTag: true };
    switch (type) {
      case 'emailUsers':
        this.selectedEmailSendToObjectsArray = this.selectedEmailSendToObjectsArray.filter(data => data.email !== tag.email);
        this.selectedEmailSendToObjectsArray.push(tempTag);
        break;
      case 'ccUsers':
        this.selectedEmailCCObjectsArray = this.selectedEmailCCObjectsArray.filter(data => data.email !== tag.email);
        this.selectedEmailCCObjectsArray.push(tempTag);
        break;
      case 'bccUsers':
        this.selectedEmailBCCObjectsArray = this.selectedEmailBCCObjectsArray.filter(data => data.email !== tag.email);
        this.selectedEmailBCCObjectsArray.push(tempTag);
        break;
      default:
        break;
    }
    return tempTag;
  }

  emailTypeAheadAdded(tag: any, type: string) {
    if (!tag.id) {
      tag.email = tag.email ? tag.email : tag.name;
      const addNewTag = this._setEmailNewTag(tag, type);
      this.emailDetails[type].push({ email: addNewTag.email, name: addNewTag.name });
    } else {
      this.emailDetails[type].push(tag);
    }

    if ((!tag.id || !tag.staffingCompany) && !this.showClientForReviewCheckbox) {
      this.showClientForReviewCheckbox = true;
    }
  }

  emailTypeAheadRemoved(tag: any, type: string) {
    this.emailDetails[type] = this.emailDetails[type].filter((email: any) => email.email !== tag.email);
    this.checkIfNonStaffingCompanyUserExists(this.emailDetails);
  }

  checkIfNonStaffingCompanyUserExists(emailDetails: any) {
    this.showClientForReviewCheckbox = false;
    const EmailUsersFieldList = ['emailUsers', 'ccUsers', 'bccUsers'];
    for (const user of EmailUsersFieldList) {
      for (const data of emailDetails[user]) {
        if (!data.id || !data.staffingCompany) {
          this.showClientForReviewCheckbox = true;
          return;
        }
      }
    }
  }

  private _setUserToEmailSearchObject() {
    this.searchUsersForEmail = {};
    this.searchUsersForEmail.email = '';
    this.searchUsersForEmail.firstName = '';
    this.searchUsersForEmail.lastName = '';
    this.searchUsersForEmail.onlyRequisitionUsers = this.isRequisitionUsersSelected;
    this.searchUsersForEmail.searchInCompanies = [];
    this.searchUsersForEmail.searchString = '';
    this.searchUsersForEmail.loggedInCompanyId = this.companyId;
    if (this.candidateDetails.context === 'candidateJobMatchCard') {
      const clientOrBuId = this.candidateDetails.clientOrBuId ? this.candidateDetails.clientOrBuId : this.companyId;
      this._setCompanyUserObject(clientOrBuId, this.candidateDetails.jobMatchRequisitionId, this.candidateDetails.jobMatchId);
    } else {
      if (this.candidateJobMatchFolders.length > 0) {
        this.candidateJobMatchFolders.map(candidateJobMatch => {
          const clientOrBuId = candidateJobMatch.jobMatch.clientOrBuId ? candidateJobMatch.jobMatch.clientOrBuId : this.companyId;
          this._setCompanyUserObject(clientOrBuId, candidateJobMatch.jobMatch.jobId, candidateJobMatch.jobMatch.jobMatchId);
        });
      }
    }

    if (this.searchUsersForEmail.searchInCompanies.length === 0) {
      this.searchUsersForEmail.searchInCompanies.push({
        companyOrClientBuId: this.companyId,
        loggedInCompanyId: this.companyId,
        vendorId: this.candidateDetails.vendorId ? this.candidateDetails.vendorId : null
      });
    }
  }

  private _setCompanyUserObject(clientOrBuId: any, requisitionId: any, jobMatchId: any) {
    const companyUserObject: any = {
      companyOrClientBuId: this.companyId,
      requisitionId,
      jobMatchId,
      loggedInCompanyId: this.companyId,
      vendorId: this.candidateDetails.vendorId ? this.candidateDetails.vendorId : null
    };

    this.searchUsersForEmail.searchInCompanies.push(companyUserObject);

    if (companyUserObject.companyOrClientBuId !== clientOrBuId) {
      const clientUserObject = Object.assign({}, companyUserObject);
      clientUserObject.companyOrClientBuId = clientOrBuId;
      this.searchUsersForEmail.searchInCompanies.push(clientUserObject);
    }
  }

  private _filterToCcBccExistingEmails(data: any[], type: string) {
    let existingEmailArray: any[] = [];
    const existingEmailIds: any[] = [];
    if (type === 'to') {
      existingEmailArray = [...this.selectedEmailSendToObjectsArray];
    } else if (type === 'cc') {
      existingEmailArray = [...this.selectedEmailCCObjectsArray];
    } else if (type === 'bcc') {
      existingEmailArray = [...this.selectedEmailBCCObjectsArray];
    }

    if (existingEmailArray.length > 0) {
      existingEmailArray.map(val => existingEmailIds.push(val.email));
    }
    return data.filter(val => !existingEmailIds.includes(val.email));
  }

  getEmailIds(searchTerm: string, type: string) {
    const tempSearchUserForEmail = _.cloneDeep(this.searchUsersForEmail);
    if (tempSearchUserForEmail) {
      tempSearchUserForEmail.searchString = searchTerm;
      tempSearchUserForEmail.onlyRequisitionUsers = this.isRequisitionUsersSelected;
      if (!tempSearchUserForEmail.onlyRequisitionUsers) {
        tempSearchUserForEmail.searchInCompanies.map((data: any) => {
          data.requisitionId = null;
        });
      }
      return this.userService.getFilteredUsersToEmail(tempSearchUserForEmail).then((data: any) => {
        const filteredEmails = this._filterToCcBccExistingEmails(data, type);
        filteredEmails.forEach((val: any) => {
          const fullName = `${val.firstName ? val.firstName : ''} ${val.lastName ? val.lastName : ''}`;
          val.name = fullName;
          val.displayString = `${fullName} (${val.email} ${val.companyName ? ', ' + val.companyName : ''})`;
          val.isCompanyUser = this._setCompanyUser(val);
        });
        return filteredEmails;
      });
    } else {
      return Promise.resolve([]);
    }
  }

  addNewEmployee() {
    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    setTimeout(() => {
      const candidateProfileActionsModal = this.bsModalService.show(CandidateProfileActionsModalComponent, {
        initialState: {
          actionType: 'addEmployee',
          actionLabel: 'Add Employee'
        },
        class: 'custom-candidate-profile-modal custom-modal-xl'
      });

      candidateProfileActionsModal.content.onClose.subscribe(() => {
        // do nothing
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      });
    }, 300);
  }

  private _setCandidateAssessmentReports() {
    if (this.candidateDetails && this.candidateDetails.resumeFileName && this.candidateDetails.resumeFileName !== '') {
      this.candidateAssessmentFiles.push(
        { name: 'Resume', fileName: '', isSelected: false, resumeNameOrXrXml: this.candidateDetails.resumeFileName });
      this.candidateAssessmentFiles.push(
        { name: 'Resume HR Xml', fileName: '', isSelected: false, resumeNameOrXrXml: this.candidateDetails.resumeXRXml });
    }
  }

  private _setEmailBodyPrePopulatedInformation() {
    const prePopulatedEmailSignature =
      `<p><br/></p><p><br/></p><p><br/></p><p id="signature">Thank You!</p><p><b>${this.loggedInUserName}</b></p><br/><br/>`;
    this.emailDetails.body = prePopulatedEmailSignature;
    this.displayedBody = prePopulatedEmailSignature;
  }

  private _setPrePopulatedEmailUsersList(jobMatchId: any) {
    const jobMatchIdsArray: any[] = [];
    let jobMatchIds = '';
    if (jobMatchId) {
      jobMatchIdsArray.push(jobMatchId);
    } else {
      if (this.candidateJobMatchFolders.length > 0) {
        this.candidateJobMatchFolders.map(data => {
          jobMatchIdsArray.push(data.jobMatch.jobMatchId);
        });
      }
    }
    jobMatchIds = jobMatchIdsArray.toString();

    this.userService.getUsersToPrePopulate(this.companyId, this.isRequisitionUsersSelected, jobMatchIds).then((data: any[]) => {
      const selectedUsersIds = this.selectedEmailSendToObjectsArray.length > 0
        ? this.selectedEmailSendToObjectsArray.map(selectedEmail => selectedEmail.id) : this.selectedEmailSendToObjectsArray;
      data.map(prePopulatedUser => {
        if (prePopulatedUser && prePopulatedUser.id && !selectedUsersIds.includes(prePopulatedUser.id)) {
          prePopulatedUser.name =
            `${prePopulatedUser.firstName ? prePopulatedUser.firstName : ''} ${prePopulatedUser.lastName ? prePopulatedUser.lastName : ''}`;
          prePopulatedUser.isCompanyUser = this._setCompanyUser(prePopulatedUser);
          if (this.selectedEmailCCObjectsArray.every(user => user.id !== prePopulatedUser.id)) {
            if (this.candidateDetails && this.candidateDetails.candidateEmail) {
              this.selectedEmailCCObjectsArray.push(prePopulatedUser);
              this.emailDetails.ccUsers.push(prePopulatedUser);
            } else {
              this.selectedEmailSendToObjectsArray.push(prePopulatedUser);
              this.emailDetails.emailUsers.push(prePopulatedUser);
            }
          }
        }

        if (prePopulatedUser && !prePopulatedUser.staffingCompany) {
          this.showClientForReviewCheckbox = true;
        }
      });
      this.isPrePopulatedUsersAvailable = true;
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      this.isPrePopulatedUsersAvailable = true;
    });
  }

  private _setCompanyUser(prePopulatedUser: any) {
    let isCompanyUser: any = false;
    if (!this.isStaffingCompany) {
      if (prePopulatedUser.staffingCompany) {
        isCompanyUser = true;
      }
    } else {
      isCompanyUser = prePopulatedUser.staffingCompany;
    }
    return isCompanyUser;
  }

  viewDocumentFIle(file: any) {
    this.sharedService.viewDocumentFile(file, () => { }, () => { });
  }

  trackByIndex(index: number) {
    return index;
  }

  // Toggles a recipient chip's display between its friendly name and its raw email.
  onTagClicked(tag: any) {
    if (tag.name === tag.email) {
      if (tag.id && (tag.firstName || tag.lastName)) {
        tag.name = tag.originalName ? tag.originalName.slice() : tag.name;
      }
    } else {
      tag.originalName = tag.name;
      tag.name = tag.email;
    }
  }

  getCustomTagClass(tag: any): string {
    if (tag.isNewTag) {
      return 'new-email-user-tag';
    }
    if (this.isStaffingCompany) {
      if (tag && !tag.isCompanyUser) {
        return 'other-company-user-tag';
      }
    } else {
      if (tag && tag.isCompanyUser) {
        return 'other-company-user-tag';
      }
    }
    return '';
  }

  // Simplified from the legacy getCustomAutoCompleteClass(match, selected): ngx-chips'
  // tag-input-dropdown template does not expose a per-item "currently highlighted" flag,
  // so only the "other company" coloring is preserved here; the dropdown's own
  // highlight styling is handled internally by the library.
  getCustomAutoCompleteClass(match: any): string {
    if (!match) {
      return '';
    }
    if (this.isStaffingCompany) {
      if (!match.isCompanyUser) {
        return 'other-company-auto-complete-user-tag';
      }
    } else {
      if (match.isCompanyUser) {
        return 'other-company-auto-complete-user-tag';
      }
    }
    return '';
  }

  private _handleFilterDisplay() {
    ($(document) as any).ready(() => {
      const panel = $('#candidate-information-panel');
      const chevronDown = $('#open-candidate-information-filter .fa-chevron-down');
      const chevronUp = $('#open-candidate-information-filter .fa-chevron-up');

      panel.hide();
      chevronUp.hide();
      chevronDown.show();

      $(document)
        .off('click', '#open-candidate-information-filter')
        .on('click', '#open-candidate-information-filter', () => {
          panel.animate({ height: 'toggle' }, 200, () => {
            if (panel.is(':visible')) {
              chevronDown.hide();
              chevronUp.show();
            } else {
              chevronUp.hide();
              chevronDown.show();
            }
          });
        });
    });
  }

  addCandidateInformationToBody(candidate: any) {
    if (candidate.selected) {
      const paragraphToInsert = this._setCandidateInfoInParagraph(candidate);

      const originalString = this.emailDetails.body;
      const signatureIndex = originalString.indexOf(`<p id="signature">`);

      if (signatureIndex !== -1) {
        this.emailDetails.body =
          originalString.slice(0, signatureIndex) +
          paragraphToInsert +
          originalString.slice(signatureIndex);
      } else {
        this.emailDetails.body += paragraphToInsert;
      }
    } else {
      const tempElement = document.createElement('div');
      tempElement.innerHTML = this.emailDetails.body;

      const pToRemove = tempElement.querySelector(`span[id="${candidate.id}"]`);
      if (pToRemove) {
        pToRemove.parentNode.removeChild(pToRemove);
      }

      this.emailDetails.body = tempElement.innerHTML;
    }
  }

  private _setCandidateInfoInParagraph(candidate: any) {
    const paragraph = `<span id="${candidate.id}" contenteditable="true">
        <b>${candidate.name}:</b> ${candidate.value || 'Not Specified'}
    </span>`;
    return paragraph;
  }

  selectAllCandidateInformation(selectAll: boolean) {
    if (!this.candidateInformationList || this.candidateInformationList.length === 0) { return; }

    this.candidateInformationList.forEach(candidate => {
      candidate.selected = selectAll;
      this.addCandidateInformationToBody(candidate);
    });
  }

  emailContentChange(event: string) {
    this.emailDetails.body = event;
    this.displayedBody = event;

    const editorElem = document.querySelector('app-ngx-editor [contenteditable="true"]');
    let hasDocSection: boolean;
    if (editorElem) {
      const docSection = editorElem.querySelector('#email-documents-section');
      const docHeader = editorElem.querySelector('#doc-attach-header');
      hasDocSection = (!!docSection && docSection.textContent.trim() !== '') ||
        (!!docHeader && docHeader.textContent.trim() !== '');
    } else {
      hasDocSection = event.includes('id="doc-attach-header"') || event.includes('id=\'doc-attach-header\'');
    }
    if (!hasDocSection) {
      const hasSelectedDocs =
        (this.attachedDocuments && this.attachedDocuments.length > 0) ||
        (this.candidateAssessmentFiles || []).some(f => f.isSelected);
      if (hasSelectedDocs) {
        if (this.candidateAssessmentFiles) {
          this.candidateAssessmentFiles.forEach(f => { f.isSelected = false; });
        }
        this.attachedDocuments = [];
        this.documentsSectionHtml = '';
      }
    }
  }

  onSelectedFieldsChange(selectedFields: any[]) {
    this.selectedCandidateFieldsForReview = selectedFields.map(field => {
      const originalField = this.candidateInformationList.find(c => c.id === field.id);
      if (originalField) {
        return {
          id: field.id,
          name: field.name || originalField.name,
          value: originalField.value || field.value,
          selected: true
        };
      }
      return field;
    });
  }

  onCandidateSelectionSync(updatedList: any[]) {
    if (!updatedList || !this.candidateInformationList) { return; }
    updatedList.forEach(updated => {
      const local = this.candidateInformationList.find(c => c.id === updated.id);
      if (local) {
        local.selected = updated.selected;
      }
    });
    this.selectAllCandidatesExternal = this.candidateInformationList.every(c => c.selected);
    this.candidateInformationList = [...this.candidateInformationList];
  }

  onExternalSelectAll(checked: boolean) {
    this.selectAllCandidatesExternal = checked;
    if (this.candidateInformationList) {
      this.candidateInformationList.forEach(c => c.selected = checked);
    }
    this.externalCandidateAction = { type: 'selectAll', selectAll: checked, timestamp: Date.now() };
  }

  onExternalCandidateToggle(candidate: any) {
    this.externalCandidateAction = { type: 'single', candidate, timestamp: Date.now() };
    if (this.candidateInformationList) {
      this.selectAllCandidatesExternal = this.candidateInformationList.every(c => c.selected);
    }
  }

  adjustAttachedDocumentsHeight() {
    const $emailFormSection = $('#emailFormSection');
    const $attachDocumentsSection = $('#attachDocumentsSection');
    const $otherDocumentsSection = $('#otherDocumentsSection');
    const $loadingSpinner = $('#loadingSpinner');

    if ($emailFormSection.length === 0 || $attachDocumentsSection.length === 0) {
      return;
    }

    const updateHeight = () => {
      const emailFormHeight = $emailFormSection.outerHeight();
      if (emailFormHeight > 0) {
        $attachDocumentsSection.css('max-height', 'none');
        $attachDocumentsSection.css('overflow-y', 'visible');

        const remainingHeight = emailFormHeight - 110;

        if (remainingHeight > 100) {
          $otherDocumentsSection.css('max-height', remainingHeight + 'px');
          $loadingSpinner.css('max-height', remainingHeight + 'px');
        } else {
          $otherDocumentsSection.css('max-height', '100px');
          $loadingSpinner.css('max-height', '100px');
        }
      }
    };

    setTimeout(() => {
      updateHeight();
    }, 100);

    setTimeout(() => {
      updateHeight();
    }, 500);

    this.adjustHeightObserver = new MutationObserver(() => {
      updateHeight();
    });

    this.adjustHeightObserver.observe($emailFormSection[0], {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });

    this.adjustHeightResizeHandler = updateHeight;
    $(window).on('resize', this.adjustHeightResizeHandler);
  }
}
